import { useState, useEffect } from 'react';

/**
 * Simple hook to get user details from sessionStorage
 * @returns {Object|null} User details object or null if not found
 */
const useUserDetails = () => {
  const [userDetails, setUserDetails] = useState(null);

  useEffect(() => {
    try {
      const storedUser = sessionStorage.getItem('user_details');
      if (storedUser) {
        const user = JSON.parse(storedUser);
        setUserDetails(user);
      }
    } catch (error) {
      console.error('Error parsing user details from sessionStorage:', error);
      setUserDetails(null);
    }
  }, []);

  // Update when sessionStorage changes
  useEffect(() => {
    const handleStorageChange = () => {
      try {
        const storedUser = sessionStorage.getItem('user_details');
        if (storedUser) {
          const user = JSON.parse(storedUser);
          setUserDetails(user);
        } else {
          setUserDetails(null);
        }
      } catch (error) {
        console.error('Error parsing user details from sessionStorage:', error);
        setUserDetails(null);
      }
    };

    // Listen for storage events (when storage changes in other tabs/windows)
    window.addEventListener('storage', handleStorageChange);

    // Also listen for custom event for same-tab updates
    window.addEventListener('userDetailsUpdated', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('userDetailsUpdated', handleStorageChange);
    };
  }, []);

  return userDetails;
};

export default useUserDetails;

